/* eslint-disable @typescript-eslint/no-explicit-any */
import { constants } from 'apps'
import { useAppDispatch, useLocalStorage } from 'hooks'
import RankingItemStyled from './styled'
import { shortenRaceNameV2 } from 'utils/helper'

import RankCount from '../RankCount'
import { RankingDonate } from 'models/ranking'
import { updateStateModal } from 'features/Profile/profile.slice'
import { AVATAR_DEFAULT } from 'assets/images'

interface RankItemProps {
  ranking: RankingDonate
}

function RankingItem({ ranking }: RankItemProps) {
  const [userId] = useLocalStorage(constants.USER_ID_KEY, 0)
  const dispatch = useAppDispatch()

  const showModalInfo = (user_id: number) => () => {
    dispatch(updateStateModal({
      isOpen: true,
      userId: user_id
    }))
  }

  return (
    <RankingItemStyled mySelf={userId === ranking?.user_id}>
      <td className='color-white stt center width-20'>
        <RankCount rank={ranking?.rank_index} />
      </td>
      <td className='color-white horse-name width-20'>
        <div className='horse-name-content'>
          <img
            width={38}
            height={38}
            style={{ borderRadius: '100%', objectFit: 'cover' }}
            src={ranking?.avatar || AVATAR_DEFAULT}
            alt='avatar'
            className='horse-avatar'
          />
          <span onClick={showModalInfo(ranking?.user_id)}>{shortenRaceNameV2(ranking?.user_name, 20)}</span>
        </div>
      </td>
      <td className='color-white width-10'>
        <span>{ranking?.item_donate}</span>
      </td>
      <td className='color-white width-10'>
        <span>{ranking?.ticket_donate}</span>
      </td>
      <td className='color-white width-10'>
        <span>{ranking?.adil_donate}</span>
      </td>
      <td className='color-white width-10'>
        <span>{ranking?.kuda_donate}</span>
      </td>
      <td className='color-white width-10'>
        <span>{ranking?.merah_donate}</span>
      </td>
      <td className='color-white width-10'>
        <span>{ranking?.booster_donate}</span>
      </td>
    </RankingItemStyled>
  )
}

export default RankingItem
